import React, {useState, useEffect} from 'react'
import { Grid, makeStyles } from '@material-ui/core';
import ModalBase from '../../../../../components/Modals/ModalBase';
import DisplayText from '../../../../../components/Texts/DisplayText';
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText';
import LineInputSelect from '../../../../../components/Inputs/LineInputSelect/LineInputSelect';
import { generalCatalogs } from '../../../../../variables/catalogs';
import SubmitModalButton from '../../../../../components/Buttons/SubmitModalButton';
import { onValidateForm } from '../../../../../shared/utility';
import {request_add_credit_card} from '../../requests'

const useStyles = makeStyles(theme => ({
    root:{
        position:'relative'
    },
    buttonContainer:{
        marginTop:32
    }
}))

const AddCreditCardModal = props => {

    const classes = useStyles()
    const {open, onClose, onUpdateCreditCards, patientID} = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [valid, setValid] = useState(false)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(open) setForm(JSON.parse(JSON.stringify(formData)))
    }, [open])



    const onInputChange = (data) => {
        const id = data.config.id;
        let temp = {...form};
        temp[id] = {...data};
        setValid(onValidateForm(temp))
        setForm(temp)
    }

    const onEdit = async() => {
        if(!valid){
            setError('Llena los campos faltantes')
            return
        }
        
        let data2send = {patient_id: patientID}
        Object.keys(form).forEach(item => {
            if((form[item].isValid)) data2send = {...data2send, [item]: form[item].value}
        })
        setLoading(true)
        try {
            const creditcards = await request_add_credit_card(patientID, data2send)
            setLoading(false)
            onUpdateCreditCards(creditcards)
            onClose()
        } catch (error) {
            console.log(error)
            setError('Hubo un error')
            setLoading(false)
        }

    }

    return(
        <ModalBase open={open} onClose={onClose}>
            <div className={classes.root}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DisplayText variant='h6'>Añadir tarjeta de crédito</DisplayText>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <LineInputText
                                data={form.name}
                                onChange={onInputChange}/>
                            </Grid>
                            <Grid item xs={12}>
                                <LineInputSelect
                                data={form.credit_range_id}
                                onChange={onInputChange}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <SubmitModalButton label='Agregar' error={error} loading={loading} onSubmit={onEdit}/>
                    </Grid>
                </Grid>
            </div>
        </ModalBase>
    )
}

export default AddCreditCardModal

const formData = {
    name:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
          id:'name',
          type:'text',
          fullWidth: true,
          label:'Nombre',
          placeholder:'Ingrese un nombre para identificar la tarjeta...'
        },
        rules:{type:'distance'}
    },
    credit_range_id:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        options:[...generalCatalogs.credit_ranges ],
        config:{
          id:'credit_range_id',
          type:'select',
          fullWidth: true,
          label:'Rango de crédito',
          placeholder:'Seleccione una opción...'
        },
        rules:{
          type:'select',
        }
    },
}